export default __webpack_public_path__ + "static/shipmentManagementVp2-4-d0d600000ca64652eb84bb0a473b6723.png";